import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function NlmGridSkeleton() {
  return (<>
    <div className='d-flex justify-content-start'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
    <div className='d-flex justify-content-start'>
      <Skeleton animation="wave" width={150} height={50} className='me-3' />
      <Skeleton animation="wave" width={150} height={50} />
    </div>
  </>);
}

export default NlmGridSkeleton;